import ApplicationAdapter from '../application';

export default class BulkImport extends ApplicationAdapter {
  namespace = 'people/v4';
  modelNamePlural = 'bulkImports';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('people/', '')
      .toLowerCase();
  }
}
